import { useEffect } from "react";
import { ChevronLeft, ChevronRight, X } from "lucide-react";

export default function ImageLightbox({ items, index, onClose, onChange }) {
  const current = index == null ? null : items[index];
  useEffect(() => {
    if (!current) return;
    const key = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowLeft") onChange((index - 1 + items.length) % items.length);
      if (e.key === "ArrowRight") onChange((index + 1) % items.length);
    };
    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", key);
    return () => { document.body.style.overflow = ""; window.removeEventListener("keydown", key); };
  }, [current, index, items.length, onClose, onChange]);
  if (!current) return null;
  const prev = () => onChange((index - 1 + items.length) % items.length);
  const next = () => onChange((index + 1) % items.length);
  return <div className="image-lightbox" role="dialog" aria-modal="true" aria-label="Image preview" onClick={onClose}>
    <button className="lightbox-close" onClick={onClose} aria-label="Close"><X size={25}/></button>
    {items.length > 1 && <button className="lightbox-nav lightbox-prev" onClick={(e)=>{e.stopPropagation();prev();}} aria-label="Previous image"><ChevronLeft size={34}/></button>}
    <div className="lightbox-stage" onClick={(e)=>e.stopPropagation()}>
      <img src={current.image_data} alt={current.title || "Wedding Touch photograph"}/>
      {(current.title || current.category) && <div className="lightbox-caption"><span>{current.title}</span>{current.category && <small>{current.category}</small>}</div>}
      <div className="lightbox-count">{index + 1} / {items.length}</div>
    </div>
    {items.length > 1 && <button className="lightbox-nav lightbox-next" onClick={(e)=>{e.stopPropagation();next();}} aria-label="Next image"><ChevronRight size={34}/></button>}
  </div>;
}
